import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { CompanyProvider } from "./contexts/CompanyContext";
import { Toaster } from "./components/ui/sonner";
import { AppLayout } from "./components/AppLayout";

// Marketing pages
import HomePage from "./pages/HomePage";
import FeaturesPage from "./pages/FeaturesPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";

// App pages
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import UpgradeSuccessPage from "./pages/UpgradeSuccessPage";
import DashboardPage from "./pages/DashboardPage";
import EmployeesPage from "./pages/EmployeesPage";
import PAFsPage from "./pages/PAFsPage";
import PAFDetailPage from "./pages/PAFDetailPage";
import ActivityPage from "./pages/ActivityPage";
import AuditTrailPage from "./pages/AuditTrailPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import CompaniesPage from "./pages/CompaniesPage";
import TeamPage from "./pages/TeamPage";
import AcceptInvitePage from "./pages/AcceptInvitePage";
import PublicPAFPage from "./pages/PublicPAFPage";
import AdminPanelPage from "./pages/AdminPanelPage";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function AppRouter() {
  return (
    <>
    <ScrollToTop />
    <Routes>
      {/* Marketing pages */}
      <Route path="/" element={<HomePage />} />
      <Route path="/features" element={<FeaturesPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsOfServicePage />} />
      <Route path="/cookies" element={<CookiePolicyPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />

      {/* Auth */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/upgrade/success" element={<UpgradeSuccessPage />} />

      {/* Public */}
      <Route path="/public/paf/:token" element={<PublicPAFPage />} />

      {/* App pages (protected) */}
      <Route path="/dashboard" element={<AppLayout><DashboardPage /></AppLayout>} />
      <Route path="/companies" element={<AppLayout><CompaniesPage /></AppLayout>} />
      <Route path="/team" element={<AppLayout><TeamPage /></AppLayout>} />
      <Route path="/employees" element={<AppLayout><EmployeesPage /></AppLayout>} />
      <Route path="/pafs" element={<AppLayout><PAFsPage /></AppLayout>} />
      <Route path="/pafs/:pafId" element={<AppLayout><PAFDetailPage /></AppLayout>} />
      <Route path="/activity" element={<AppLayout><ActivityPage /></AppLayout>} />
      <Route path="/audit-trail" element={<AppLayout><AuditTrailPage /></AppLayout>} />
      <Route path="/reports" element={<AppLayout><ReportsPage /></AppLayout>} />
      <Route path="/settings" element={<AppLayout><SettingsPage /></AppLayout>} />
      <Route path="/admin" element={<AppLayout><AdminPanelPage /></AppLayout>} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <CompanyProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
        </CompanyProvider>
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
